import { Inject, Pipe, PipeTransform } from '@angular/core';
import { JSR310ConversionService } from '../../../shared/jsr310-localdates/services/jsr310-conversion.service';
import { LocalDate } from '../../../shared/jsr310-localdates/types/local-date.type';
import { DocumentPersonneAvertieResult } from '../../../data-domains/document-securite/entities/document-personne-avertie-result';

@Pipe({
	name: 'libelleValiditePa'
})
export class LibelleValiditePaPipe implements PipeTransform {
	
	nowInMillis: number = new Date().getTime();
	
	constructor(
		@Inject(JSR310ConversionService) private conversionService: JSR310ConversionService
	) {}
	
	transform(pa: DocumentPersonneAvertieResult): string {
		if (!pa.dateFin) {
			return '';
		} else {
			let localDateFinValidite = [pa.dateFin[0], pa.dateFin[1], pa.dateFin[2]] as LocalDate;
			let dateFin = this.conversionService.fromLocalDate(localDateFinValidite);
			if (dateFin) {
				dateFin.setHours(23, 59, 59, 999); // ramener la date de fin à 23h59
				if (pa.expired = this.nowInMillis > dateFin.getTime()) {
					return 'expiré';
				} else {
					return 'en cours';
				}
			}
			return '';
		}
	}
	
}